const initialState = {
  vtexItems: {},
  loading: true,
  error: null,
  content: {},
  batchShopifySarkanyus: [],
  batchVtexSarkanyus: [],
  batchShopifyOrderSarkanyUs: [],
  batchVtexOrderSarkanyArg: [],
  batchShopifySofia: [],
batchShopifyOrderSofia: [],
paginate:{}
};

function apiReducer(state = initialState, action) {
  switch (action.type) {
    /* LOADING_START*/
    
    case "LOADING_START":
      return {
        ...state,
        loading: true,
      };
    /*VTEX PRODUCTS*/
    case "BATCH_VTEX_SUCCESS":
      if (
        JSON.stringify(state.batchVtexSarkanyus) ===
        JSON.stringify(action.payload)
      ) {
        return state;
      }
      return {
        ...state,
        loading: false,
        batchVtexSarkanyus: action.payload.items,
        paginate: action.payload.paginate
      };

    case "BATCH_VTEX_FAILURE":
      return { ...state, loading: false, error: action.payload };

    case "BATCH_VTEX_LAST_SUCCESS": {
      const updated = [...state.batchVtexSarkanyus];
      const lastIndex = updated.length - 1;
      if (lastIndex >= 0) {
        updated[lastIndex] = action.payload;
      } else {
        updated.push(action.payload);
      }
      return {
        ...state,
        batchVtexSarkanyus: updated,
      };
    }
    case "BATCH_VTEX_LAST_FAILURE":
      return { ...state, loading: false, error: action.payload };
    case "FETCH_API_VTEX_LOADING":
      return {
        ...state,
        batchVtexSarkanyus: [...state.batchVtexSarkanyus, { loading: true }],
      };

    /*vtex ORDERS*/
    case "BATCH_VTEX_ORDER_SUCCESS":
      if (
        JSON.stringify(state.batchVtexOrderSarkanyArg) ===
        JSON.stringify(action.payload)
      ) {
        return state;
      }
      return {
        ...state,
        loading: false,
        batchVtexOrderSarkanyArg: action.payload.items,
        paginate: action.payload.paginate
      };

    case "BATCH_VTEX_ORDER_FAILURE":
      return { ...state, loading: false, error: action.payload };

    case "BATCH_VTEX_ORDER_LAST_SUCCESS": {
      const updated = [...state.batchVtexOrderSarkanyArg];
      const lastIndex = updated.length - 1;
      if (lastIndex >= 0) {
        updated[lastIndex] = action.payload;
      } else {
        updated.push(action.payload);
      }
      return {
        ...state,
        batchVtexOrderSarkanyArg: updated,
      };
    }
    case "BATCH_VTEX_ORDER_LAST_FAILURE":
      return { ...state, loading: false, error: action.payload };
    case "FETCH_API_VTEX_ORDER_LOADING":
      return {
        ...state,
        batchVtexOrderSarkanyArg: [
          ...state.batchVtexOrderSarkanyArg,
          { loading: true },
        ],
      };
    /*SHOPIFY RICKY ORDERS*/
    case "BATCH_SHOPIFY_RICKY_ORDER_SUCCESS":
      if (
        JSON.stringify(state.batchShopifyOrderSarkanyUs) ===
        JSON.stringify(action.payload)
      ) {
        return state;
      }
      return {
        ...state,
        loading: false,
        batchShopifyOrderSarkanyUs: action.payload,
      };

    case "BATCH_SHOPIFY_RICKY_ORDER_FAILURE":
      return { ...state, loading: false, error: action.payload };

    case "BATCH_SHOPIFY_RICKY_ORDER_LAST_SUCCESS": {
      const updated = [...state.batchShopifyOrderSarkanyUs];
      const lastIndex = updated.length - 1;
      if (lastIndex >= 0) {
        updated[lastIndex] = action.payload;
      } else {
        updated.push(action.payload);
      }
      return {
        ...state,
        batchShopifyOrderSarkanyUs: updated,
      };
    }
    case "BATCH_SHOPIFY_RICKY_ORDER_LAST_FAILURE":
      return { ...state, loading: false, error: action.payload };
    case "FETCH_API_SHOPIFY_RICKY_ORDER_LOADING":
      return {
        ...state,
        batchShopifyOrderSarkanyUs: [
          ...state.batchShopifyOrderSarkanyUs,
          { loading: true },
        ],
      };
    /*shopify RICKY PRODUCTS*/
    case "BATCH_SHOPIFY_SUCCESS":
      if (
        JSON.stringify(state.batchShopifySarkanyus) ===
        JSON.stringify(action.payload)
      ) {
        return state;
      }
      return {
        ...state,
        loading: false,
        batchShopifySarkanyus: action.payload.items,
        paginate: action.payload.paginate
      };

    case "BATCH_SHOPIFY_FAILURE":
      return { ...state, loading: false, error: action.payload };

    case "BATCH_SHOPIFY_LAST_SUCCESS": {
      console.log("batchShopifyOrderSarkanyUs: ",state.batchShopifySarkanyus)
      console.log("action.payload: ",action.payload)

      const updated = [...state.batchShopifySarkanyus];
      const lastIndex = updated.length - 1;
      if (lastIndex >= 0) {
        updated[lastIndex] = action.payload;
      } else {
        updated.push(action.payload);
      }
      return {
        ...state,
        batchShopifySarkanyus: updated,
      };
    }
    case "BATCH_SHOPIFY_LAST_FAILURE":
      return { ...state, loading: false, error: action.payload };
    case "FETCH_API_SHOPIFY_LOADING":
      return {
        ...state,
        batchShopifySarkanyus: [
          ...state.batchShopifySarkanyus,
          { loading: true },
        ],
      };
  /*shopify RICKY ORDERS*/
    case "BATCH_SHOPIFY_ORDER_SUCCESS":
      if (
        JSON.stringify(state.batchShopifyOrderSarkanyUs) ===
        JSON.stringify(action.payload)
      ) {
        return state;
      }
      return {
        ...state,
        loading: false,
        batchShopifyOrderSarkanyUs: action.payload.items,
        paginate: action.payload.paginate
      };

    case "BATCH_SHOPIFY_ORDER_FAILURE":
      return { ...state, loading: false, error: action.payload };

    case "BATCH_SHOPIFY_ORDER_LAST_SUCCESS": {
      console.log("batchShopifyOrderSarkanyUs: ",state.batchShopifyOrderSarkanyUs)

      const updated = [...state.batchShopifyOrderSarkanyUs];
      console.log("action.payload: ",action.payload)

      const lastIndex = updated.length - 1;
      if (lastIndex >= 0) {
        updated[lastIndex] = action.payload;
      } else {
        updated.push(action.payload);
      }
      return {
        ...state,
        batchShopifyOrderSarkanyUs: updated,
      };
    }
    case "BATCH_SHOPIFY_ORDER_LAST_FAILURE":
      return { ...state, loading: false, error: action.payload };
    case "FETCH_API_SHOPIFY_ORDER_LOADING":
      return {
        ...state,
        batchShopifyOrderSarkanyUs: [
          ...state.batchShopifyOrderSarkanyUs,
          { loading: true },
        ],
      };
    
      /*PRODUCTS SOFIA */
     case "BATCH_SHOPIFY_SOFIA_SUCCESS":
      if (
        JSON.stringify(state.batchShopifySofia) ===
        JSON.stringify(action.payload)
      ) {
        return state;
      }
      return {
        ...state,
        loading: false,
        batchShopifySofia: action.payload.items,
        paginate: action.payload.paginate
      };

    case "BATCH_SHOPIFY_SOFIA_FAILURE":
      return { ...state, loading: false, error: action.payload };

    case "BATCH_SHOPIFY_SOFIA_LAST_SUCCESS": {
      console.log("batchShopifySofia: ",state.batchShopifySofia)
      console.log("action.payload: ",action.payload)

      const updated = [...state.batchShopifySofia];
      const lastIndex = updated.length - 1;
      if (lastIndex >= 0) {
        updated[lastIndex] = action.payload;
      } else {
        updated.push(action.payload);
      }
      return {
        ...state,
        batchShopifySofia: updated,
      };
    }
    case "BATCH_SHOPIFY_SOFIA_LAST_FAILURE":
      return { ...state, loading: false, error: action.payload };
    case "FETCH_API_SHOPIFY_SOFIA_LOADING":
      return {
        ...state,
        batchShopifySofia: [
          ...state.batchShopifySofia,
          { loading: true },
        ],
      };
 
        /*shopify SOFIA ORDERS*/
    case "BATCH_SHOPIFY_SOFIA_ORDER_SUCCESS":
      if (
        JSON.stringify(state.batchShopifyOrderSofia) ===
        JSON.stringify(action.payload)
      ) {
        return state;
      }
      return {
        ...state,
        loading: false,
        batchShopifyOrderSofia: action.payload.items,
        paginate: action.payload.paginate
      };

    case "BATCH_SHOPIFY_SOFIA_ORDER_FAILURE":
      return { ...state, loading: false, error: action.payload };

    case "BATCH_SHOPIFY_SOFIA_ORDER_LAST_SUCCESS": {

      const updated = [...state.batchShopifyOrderSofia];

      const lastIndex = updated.length - 1;
      if (lastIndex >= 0) {
        updated[lastIndex] = action.payload;
      } else {
        updated.push(action.payload);
      }
      return {
        ...state,
        batchShopifyOrderSofia: updated,
      };
    }
    case "BATCH_SHOPIFY_SOFIA_ORDER_LAST_FAILURE":
      return { ...state, loading: false, error: action.payload };
    case "FETCH_API_SHOPIFY_SOFIA_ORDER_LOADING":
      return {
        ...state,
        batchShopifyOrderSofia: [
          ...state.batchShopifyOrderSofia,
          { loading: true },
        ],
      };
   
    
      default:
      return state;
  }
  
}

export default apiReducer;
